import { render, staticRenderFns } from "./WidgetActualites.vue?vue&type=template&id=7cb92956&scoped=true&"
import script from "./WidgetActualites.vue?vue&type=script&lang=js&"
export * from "./WidgetActualites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb92956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cb92956')) {
      api.createRecord('7cb92956', component.options)
    } else {
      api.reload('7cb92956', component.options)
    }
    module.hot.accept("./WidgetActualites.vue?vue&type=template&id=7cb92956&scoped=true&", function () {
      api.rerender('7cb92956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Accueil/WidgetActualites.vue"
export default component.exports